import React, { useEffect, useRef, useState, useCallback } from "react";
import Axios from "../../globals/axios/axios.index";
import {
    Switch,
    IconButton,
    Snackbar,
    TextField,
    Typography,
    Paper,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Modal,
    Card,
    CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../globals/redux/store/store.index";
import * as ChatThunks from "./chat.thunks";
import * as ChatActions from "./chat.actions";
import { handleFetchMessages } from "./chat.thunks";
import { Mic, MicOff, Close, Chat, PushPin, Videocam } from "@mui/icons-material";
// import "./chat.index.less";
import "./av-chat.index.less";
import AudioMessage from "./components/message/audioMessage.index";
import TextMessage from "./components/message/textMessage.index";
import SummaryMessage from "./components/message/summaryMessage.index";
import RestartConversationDialog from "./components/dialogs/restartConversation.index";
import FeedbackDialog from "./components/dialogs/feedback.index";
import VoiceListening from "./components/dialogs/voiceListening.index";
import { useWhisper } from "./hooks/useWhisper";
import mgVideoImageUrl from "../../assets/images/mg-video-image.png";
import VideoMessage from "./components/message/videoMessage.index";
import { ChatHistoryService } from "../../services/chatHistoryService";
import { ConversationSharingService } from "../../services/conversationSharingService";
import { RenameSessionService } from "../../services/renameSessionService";
import { DeleteSessionService } from "../../services/deleteSessionService";
import { PinUnpinSessionService } from "../../services/pinUnpinSessionService";
import { useVoiceVisualizer, VoiceVisualizer } from "react-voice-visualizer";
import InforDialog from "./components/dialogs/InforDialog.index";
import { LoadingIcon, MicButton, NoChat } from "../../assets/svgicons";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import copy from "copy-to-clipboard";
import ShareIcon from '../../assets/svgicons/Share.svg';
import RenameIcon from '../../assets/svgicons/Rename.svg';
import DeleteIcon from '../../assets/svgicons/Delete.svg';
import PinIcon from '../../assets/svgicons/Pin.svg';
import UnpinIcon from '../../assets/svgicons/unpin.svg';
import GroupActionsIcon from '../../assets/svgicons/GroupActions.svg';
import SpeechToText from '../../assets/svgicons/SpeechToText.svg';
import AudioCallIcon from '../../assets/svgicons/AudioCallIcon.svg';
import SendMessageIcon from '../../assets/svgicons/Send-plane.svg';
import PlusIcon from '../../assets/svgicons/Plus.svg';
import Footer from "../Footer/Footer.index";
import AudioCallComponent from "../realtimeVoiceBot/AudioCallComponent";
import AvatarComponent from "./components/message/videoAvatar.index";
// import { fetchAccessToken } from "../../services/heygenAccessToken";
import GraphicEqIcon from '@mui/icons-material/GraphicEq';




const ChatV2: React.FC<{ onLandingPage?: boolean }> = (onLandingPage) => {
    const dispatch = useDispatch();
    const chatState = useSelector<RootState, { [key: string]: any }>(
        (state) => state.chatV2Reducer,
    );
    const canAccessQnA = localStorage.getItem("canAccessQnA") == 'yes' ? true : false;
    const [isVideoModeOn, setIsVideoModeOn] = useState(false);
    // Sidebar toggle for mobile
    const [showSidebar, setShowSidebar] = useState(false);
    const [isAudioCallOpen, setIsAudioCallOpen] = useState(false);
    const messagesRef = useRef<HTMLDivElement>();
    const inputRef = useRef<HTMLInputElement>(null);
    const videoRef = useRef<HTMLVideoElement>();
    const freeUsage = localStorage.getItem('freeUsageAllowed')
    let showNotNeededComponents = localStorage.getItem('authenticatedUser') ? true : false;

    const [messageInputType, setMessageInputType] = useState<"text" | "voice">(
        "text",
    );
    const [input, setInput] = useState<string>("");

    const [isTyping, setIsTyping] = useState(false);
    const [chatStarted, setChatStarted] = useState<boolean>(false);

    const [feedbackMap, setFeedbackMap] = useState<Record<any, any>>({});
    const [messageIdForFeedback, setMessageIdForFeedback] = useState<
        string | null
    >(null);
    const [showFeedbackDialog, setShowFeedbackDialog] =
        useState<boolean>(false);

    const [isSummaryLoading, setIsSummaryLoading] = useState(false);
    const [summaryError, setSummaryError] = useState<string | null>(null);

    const [audioMessageMap, setAudioMessageMap] = useState<
        Record<string, string[]>
    >({});
    const [currentlyPlayingAudioMessage, setCurrentlyPlayingAudioMessage] =
        useState<string | null>(null);

    const [videoMessageMap, setVideoMessageMap] = useState<
        Record<string, string[]>
    >({});
    const [currentlyPlayingVideoMessage, setCurrentlyPlayingVideoMessage] =
        useState<string | null>(null);

    const [showRecordingDialog, setShowRecordingDialog] =
        useState<boolean>(false);
    const [confirmationDialogOpen, setConfirmationDialogOpen] =
        useState<boolean>(false);

    const [videoUrlsToPlay, setVideoUrlsToPlay] = useState<string[]>([]);
    const videoUrlsIndex = useRef<number>(0);
    const navigate = useNavigate();
    const [snackbarProps, setSnackProps] = useState<{
        open: boolean;
        message: string | null;
    }>({
        open: false,
        message: null,
    });

    const {
        secondsRef,
        transcript,
        transcribing,
        startRecording,
        stopRecording,
        resetTranscript,
        stopUpdatingSeconds,
    } = useWhisper({
        removeSilence: true,
        timeSlice: 2_000,
        streaming: true,
    });
    // Covers the moment between stopping and the hook setting `transcribing`, so the recording area doesn't flicker
    const [isStopping, setIsStopping] = useState(false);
    const showTranscribing = transcribing || isStopping;
    const markStopping = () => {
        setIsStopping(true);
        setTimeout(() => setIsStopping(false), 1500); // safety net if transcription never starts
    };
    useEffect(() => {
        if (transcribing) setIsStopping(false);
    }, [transcribing]);
    const recorderControls = useVoiceVisualizer();
    const {
        audioRef,
        startRecording: startVisualRecording,
        stopRecording: stopVisualRecording,
    } = recorderControls;
    const [time, setTime] = useState({ minutes: 0, seconds: 0 });
    const [isRunning, setIsRunning] = useState(false);
    const cardContent = [
        {
            id: 1,
            image: require("../../assets/images/HeroCard1.jpg"),
            category: "STAKEHOLDER CENTERED COACHING",
            text: "Can you explain the concept of Stakeholder Centered Coaching?",
        },
        {
            id: 2,
            image: require("../../assets/images/HeroCard2.jpg"),
            category: "WHAT GOT YOU HERE",
            text: "What are some key takeaways from your book 'What Got You Here Won't Get You There'?",
        },
        {
            id: 3,
            image: require("../../assets/images/HeroCard3.jpg"),
            category: "LEADERSHIP ADVICE",
            text: "What is the most important piece of advice you would give to someone looking to improve their leadership skills?",
        },
    ];
    const [infoModal, setInfoModal] = useState(false);
    const [overloadOpen, setOverloadOpen] = useState(false);
    const [isDesktop, SetIsDesktop] = useState("desktop");
    const observer = useRef<IntersectionObserver | null>(null);




    const CheckWindowSize = () => {
        let windowWidth;
        if (typeof window !== "undefined") {
            windowWidth = window.innerWidth;
        }
        if (windowWidth >= 1024) {
            SetIsDesktop("desktop");
            setShowSidebar(true);
        } else {
            SetIsDesktop("mobile");
            // For mobile, always start with sidebar hidden
            setShowSidebar(false);
        }

    }


    // const fetchAndStoreToken = async () => {
    //     const token = await fetchAccessToken();
    //     sessionStorage.setItem('accessToken', token);
    // };

    const [searchParams] = useSearchParams();
    useEffect(() => {
        CheckWindowSize();
        // fetchAndStoreToken();
        const sessionID = searchParams.get('s');
        if (sessionID) {
            handleFetchMessagesClick(sessionID)
        }

        // Add resize event listener for responsive updates
        window.addEventListener("resize", CheckWindowSize);

        // Set an interval to call the function every 12 hours for a new token(12 hours = 43200000ms)
        // const intervalId = setInterval(fetchAndStoreToken, 43200000);
        return () => {
            // clearInterval(intervalId);
            window.removeEventListener("resize", CheckWindowSize);
        };
    }, []);

    useEffect(() => {
        let interval;

        if (isRunning) {
            interval = setInterval(() => {
                setTime((prevTime) => {
                    const newSeconds = prevTime.seconds + 1;

                    if (newSeconds === 60) {
                        // Reset seconds to 0 and increment minutes
                        return { minutes: prevTime.minutes + 1, seconds: 0 };
                    }

                    return { ...prevTime, seconds: newSeconds };
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [isRunning]);

    const handleVoiceVisualizer = () => {
        // audioRef.current.startRecording()
        startVisualRecording();
    };

    useEffect(() => {
        // console.log(`Elapsed seconds: ${secondsRef.current}`);

        if (secondsRef.current >= 5) {
            // autoSendMessage();
            markStopping();
            stopRecording();
            setIsRunning(false);
            setTime({ minutes: 0, seconds: 0 });
            stopVisualRecording();
            stopUpdatingSeconds();
            resetTranscript();
            setShowRecordingDialog(false);
            setMessageInputType("text");
        }
    }, [secondsRef.current]);

    const autoSendMessage = () => {
        // console.log("Auto-sending message...");
        dispatch(
            ChatThunks.postNewMessage(
                input,
                messageInputType,
                // chatState.chatType,
                "voice",
                chatState.chatSessionId,
                true,
                isDesktop
            ),
        );

        //     if (chatState.chatType === "voice") {
        //         dispatch(ChatThunks.setChatType("text"));
        //     }

        setMessageInputType("text");
        scrollToLastMessage();
        setIsTyping(false);
        setChatStarted(true);
        stopRecording();
        setIsRunning(false);
        setTime({ minutes: 0, seconds: 0 });
        stopVisualRecording();
        setShowRecordingDialog(false);
    };

    useEffect(() => {
        if (isTyping) {
            inputRef.current.focus();
        }
    }, [isTyping]);

    useEffect(() => {
        resetTranscript();
        if (chatState.sendMessageApiStatus === "success") {
            setInput("");
            scrollToLastMessage();
        } else if (chatState.sendMessageApiStatus === "failed") {
            setInput("");
        }

        // eslint-disable-next-line
    }, [chatState.sendMessageApiStatus]);

    useEffect(() => {
        if (chatState.messageFeedbackApiStatus === "success") {
            setShowFeedbackDialog(false);
            setMessageIdForFeedback(null);

            setSnackProps({
                open: true,
                message: "Feedback submitted",
            });
            dispatch(ChatThunks.setMessageFeedbackApiStatus(null));
        } else if (chatState.messageFeedbackApiStatus === "failed") {
            setSnackProps({
                open: true,
                message: "Feedback could not be saved",
            });
            dispatch(ChatThunks.setMessageFeedbackApiStatus(null));
        }
        // eslint-disable-next-line
    }, [chatState.messageFeedbackApiStatus]);

    useEffect(() => {
        setInput(transcript.text);
    }, [transcript]);

    useEffect(() => {
        setAudioMessageMap(chatState.messageIdAudioUrls);
    }, [chatState.messageIdAudioUrls]);

    useEffect(() => {
        setVideoMessageMap(chatState.messageIdVideoUrls);
    }, [chatState.messageIdVideoUrls]);
    // console.log(chatState.messageIdVideoUrls)

    useEffect(() => {
        if (chatState.lastReceivedMessage !== null) {
            if (chatState.lastReceivedMessage.message_type === "voice") {
                setCurrentlyPlayingAudioMessage(
                    chatState.lastReceivedMessage.message_id,
                );
            } else if (chatState.lastReceivedMessage.message_type === "video") {
                setCurrentlyPlayingVideoMessage(
                    chatState.lastReceivedMessage.message_id,
                );
                const urls =
                    chatState.messageIdVideoUrls[
                    chatState.lastReceivedMessage.message_id
                    ];
                // videoRef.current.src = urls[0]
                // videoRef.current.src = urls[videoUrlsIndex.current]
                // videoRef.current.play()
                // videoRef.current.onended = () => {
                //     if (videoUrlsIndex.current <= urls.length) {
                //         videoUrlsIndex.current += 1
                //         videoRef.current.src = urls[videoUrlsIndex.current]
                //     }
                //     else {
                //         videoUrlsIndex.current = 0
                //         dispatch(ChatThunks.clearVideoUrls(chatState.lastReceivedMessage.message_id))
                //     }
                // }
                videoUrlsIndex.current = videoUrlsIndex.current || 0;

                const playNextVideo = () => {
                    if (videoUrlsIndex.current < urls.length) {
                        videoRef.current.src = urls[videoUrlsIndex.current];
                        videoRef.current.play();
                        videoUrlsIndex.current += 1;
                    } else {
                        videoUrlsIndex.current = 0;
                        dispatch(
                            ChatThunks.clearVideoUrls(
                                chatState.lastReceivedMessage.message_id,
                            ),
                        );
                    }
                };

                // Listen for the 'ended' event to play the next video in sequence
                videoRef.current.onended = playNextVideo;

                // Start playing the first video
                playNextVideo();
            }
        }
    }, [chatState.lastReceivedMessage]);

    useEffect(() => {
        setConfirmationDialogOpen(chatState.restartConversation);
    }, [chatState.restartConversation]);

    const handleExampleClick = (exampleText: string) => {
        setInput(exampleText);
        setIsTyping(true);
        inputRef.current.focus();
    };
    useEffect(() => {
        if (chatState.videoMode === "On" && !showAvatar) {
            setShowAvatar(true);
        } else if (chatState.videoMode === "Off" && showAvatar) {
            setShowAvatar(false);
        }
    }, [chatState.videoMode]);

    const [showAvatar, setShowAvatar] = useState(false);
    
    const renderMessages = () => {
        let messageComponents = [];
        // if (showAvatar) {
        //     const lastAudioMessage = chatState.messages
        //     .filter((item) => item.message_type === "voice")
        //     .pop();

        //     messageComponents.push(
        //         <AvatarComponent key={lastAudioMessage?.message_id} messageId={lastAudioMessage?.message_id} userInp={lastAudioMessage?.message} />
        //     )
        //     return <>{messageComponents}</>;
        // }
        chatState.messages.forEach((item: Record<any, any>, index: number) => {
            if (item.sender === "user") {
                // console.log("****************************************msg",item.message)
                messageComponents.push(
                    <TextMessage
                        key={index}
                        messageId={item.message_id}
                        text={item.message}
                        imgUrl={item.image_url}
                        sender={item.sender}
                        feedbackAction={feedbackMap[item.message_id]}
                        sendMessageApiStatus={chatState.sendMessageApiStatus}
                        messageFeedbackApiStatus={
                            chatState.messageFeedbackApiStatus
                        }
                        onFeedbackButtonClicked={submitFeedback}
                        onThumbsDownButtonClicked={() => {
                            setMessageIdForFeedback(item.message_id);
                            setShowFeedbackDialog(true);
                        }}
                        onTextContainerResized={scrollToLastMessage}
                        onRetryButtonClicked={() => {
                            dispatch(ChatThunks.retryLastFailedMessage());
                        }}
                        deliveryStatus={
                            item.hasOwnProperty("delivery_status")
                                ? item.delivery_status
                                : null
                        }
                        forHistory={activeChat.length > 0 ? "history" : ""}
                    />,
                );
            } else {
                // console.log("****************************************ChatState",chatState)
                if (item.message_type === "voice") {
                    // console.log("****************************************msg",item.image_url)
                    messageComponents.push(
                        <AudioMessage
                            key={index}
                            messageId={item.message_id}
                            text={item.message}
                            imgUrl={item.image_url}
                            sender={item.sender}
                            displayAudioControl={
                                index === chatState.messages.length - 1
                            }
                            audioUrlKey={
                                item.audio_url
                                    ? item.audio_url : null
                            }
                            feedbackAction={feedbackMap[item.message_id]}
                            messageFeedbackApiStatus={
                                chatState.messageFeedbackApiStatus
                            }
                            onFeedbackButtonClicked={submitFeedback}
                            onThumbsDownButtonClicked={() => {
                                setMessageIdForFeedback(item.message_id);
                                setShowFeedbackDialog(true);
                            }}
                            onTextContainerResized={scrollToLastMessage}
                            forHistory={activeChat.length > 0 ? "history" : ""}
                        />,
                    );
                } else if (item.message_type === "text") {
                    // console.log("****************************************msg",item.message)
                    messageComponents.push(
                        <TextMessage
                            key={index}
                            messageId={item.message_id}
                            text={item.message}
                            imgUrl={item.image_url}
                            sender={item.sender}
                            feedbackAction={feedbackMap[item.message_id]}
                            sendMessageApiStatus={
                                chatState.sendMessageApiStatus
                            }
                            messageFeedbackApiStatus={
                                chatState.messageFeedbackApiStatus
                            }
                            onFeedbackButtonClicked={submitFeedback}
                            onThumbsDownButtonClicked={() => {
                                setMessageIdForFeedback(item.message_id);
                                setShowFeedbackDialog(true);
                            }}
                            onTextContainerResized={scrollToLastMessage}
                            onRetryButtonClicked={() => {
                                dispatch(ChatThunks.retryLastFailedMessage());
                            }}
                            deliveryStatus={
                                item.hasOwnProperty("delivery_status")
                                    ? item.delivery_status
                                    : null
                            }
                            forHistory={activeChat.length > 0 ? "history" : ""}
                        />,
                    );
                } else if (item.message_type === "video") {
                    // messageComponents.push(
                    //     <VideoMessage
                    //         key={index}
                    //         messageId={item.message_id}
                    //         text={item.message}
                    //         sender={item.sender}
                    //         feedbackAction={feedbackMap[item.message_id]}
                    //         sendMessageApiStatus={
                    //             chatState.sendMessageApiStatus
                    //         }
                    //         messageFeedbackApiStatus={
                    //             chatState.messageFeedbackApiStatus
                    //         }
                    //         onFeedbackButtonClicked={submitFeedback}
                    //         onThumbsDownButtonClicked={() => {
                    //             setMessageIdForFeedback(item.message_id);
                    //             setShowFeedbackDialog(true);
                    //         }}
                    //         onTextContainerResized={scrollToLastMessage}
                    //         onRetryButtonClicked={() => {
                    //             dispatch(ChatThunks.retryLastFailedMessage());
                    //         }}
                    //         deliveryStatus={
                    //             item.hasOwnProperty("delivery_status")
                    //                 ? item.delivery_status
                    //                 : null
                    //         }
                    //     />,
                    // );

                }
            }
        });
        return <>{messageComponents}</>;
    };

    const updateFeedbackMap = (messageId: string, action: "TU" | "TD") => {
        let newFeedbackMap = { ...feedbackMap, ...{ [messageId]: action } };
        setFeedbackMap(newFeedbackMap);
    };
    
    
    function getMobileOperatingSystem(): string {
        const userAgent = navigator.userAgent || navigator.vendor;
        const platform = navigator.platform || '';
        const isTouchDevice = 'maxTouchPoints' in navigator && navigator.maxTouchPoints > 1;
    
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
    
        if (/android/i.test(userAgent)) {
            return "Android";
        }
    
        if (/iPad|iPhone|iPod/.test(userAgent) && isTouchDevice && !/windows/i.test(platform)) {
            return "iOS";
        }
    
        return "unknown";
    }
    
    
    // console.log('getMobileOperatingSystem()', getMobileOperatingSystem())
    // const audioType = getMobileOperatingSystem() == 'iOS' ? 'text' : 'voice'
    const audioType = 'voice';
    const submitMessage = () => {
        dispatch(ChatThunks.setChatTypeForUpdateMessage(chatState.chatType));
        if (input.trim().length > 0) {
            dispatch(
                ChatActions.setImageUrl(
                    null
                ));

            dispatch(
                ChatThunks.postNewMessage(
                    input.trim(),
                    messageInputType,
                    // chatState.chatType,
                    audioType,
                    chatState.chatSessionId,
                    true,
                    isDesktop
                ),

            );

            // Clear input immediately
            setInput("");

            if (chatState.chatType === "voice") {
                dispatch(ChatThunks.setChatType("text"));
            }

            setMessageInputType("text");
            scrollToLastMessage();
            setIsTyping(false);
            setChatStarted(true);
        }
    };

    const handleGenerateSummary = async () => {
        try {
            setIsSummaryLoading(true);
            setSummaryError(null);

            const chatToLoad = activeChat || localStorage.getItem("chat_session_id");
            if (!chatToLoad) {
                setSummaryError("No chat session found");
                setIsSummaryLoading(false);
                return;
            }

            const token = localStorage.getItem("authenticationToken");

            // Generate summary
            const generateResponse = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}api/v1/chat/${chatToLoad}/summary/generate/`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

            if (!generateResponse.ok) {
                throw new Error("Failed to generate summary");
            }

            // Fetch summary
            const fetchResponse = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}api/v1/chat/${chatToLoad}/summary/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

            if (!fetchResponse.ok) {
                throw new Error("Failed to fetch summary");
            }

            const data = await fetchResponse.json();
            if (data?.summary) {
                dispatch(ChatActions.setSummary(data.summary));
                scrollToLastMessage();
            } else {
                setSummaryError("No summary available");
            }
        } catch (error) {
            console.error("Error generating summary:", error);
            setSummaryError("Failed to generate summary. Please try again.");
        } finally {
            setIsSummaryLoading(false);
        }
    };

    const submitFeedback = (
        messageId: string,
        action: "TU" | "TD",
        feedbackText: string | null,
        checkboxResponses: string[],
    ) => {
        dispatch(
            ChatThunks.submitMessageFeedback(
                messageId,
                action,
                feedbackText,
                checkboxResponses,
            ),
        );
        resetTranscript();
        updateFeedbackMap(messageId, action);
    };

    const onSnackbarClose = () => {
        setSnackProps({
            open: false,
            message: null,
        });
    };

    const scrollToLastMessage = () => {
        setTimeout(() => {
            if (messagesRef.current) {
                messagesRef.current.scrollTop =
                    messagesRef.current.scrollHeight + 120;
            }
        }, 200);
    };

    const toggleChatInputType = () => {
        dispatch(
            ChatActions.isMicClicked(1),
        );
        setInput("");
        if (messageInputType === "text") {
            setMessageInputType("voice");
            if (chatState.chatType === "text") {
                dispatch(ChatThunks.setChatType("voice"));
            }
            startRecording();
            stopVisualRecording();
            setIsRunning(true);
            setShowRecordingDialog(true);
        } else if (messageInputType === "voice") {
            stopRecording();
            setIsRunning(false);
            if (chatState.chatType === "voice") {
                dispatch(ChatThunks.setChatType("text"));
            }
            dispatch(ChatThunks.setChatType("text"));
            setMessageInputType("text");
        }
    };

    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const handleVideoPlay = () => {
        setIsVideoPlaying(true);
    };
    const handleContactClick = () => {
        window.open("https://fractal.ai/contact-us/", "_blank");
    };
    const handleCookieClick = () => {
        window.open("/cookie", "_blank");
    };
    const handleTermsClick = () => {
        window.open("/t&c", "_blank");
    };
    const handlePrivacyClick = () => {
        window.open("/privacy", "_blank");
    };

    const [userSessions, setUserSessions] = useState([]);
    const [selectedChatId, setSelectedChatId] = useState(null);
    const [chatMessages, setChatMessages] = useState([]);
    const [activeChat, setActiveChat] = useState("");
    const [userSessionsLoading, setUserSessionsLoading] = useState("loading");
    const lastPathRef = useRef<string | null>(null);
    const location = useLocation();

    const fetchUserSessions = async () => {
        setUserSessionsLoading("loading");
        try {
            loadMoreUserSessions();
            // const response = await ChatHistoryService.fetchUserSessions();
            // setUserSessions(response.data.results);
            setUserSessionsLoading("loaded");

        } catch (error) {
            console.error("Error fetching user sessions:", error);
        }
    };

    useEffect(() => {
        const storedPath = sessionStorage.getItem("prevPath");
        if (storedPath && storedPath === "/video-chat" && chatState.videoMode == 'On' && chatState?.lastReceivedMessage?.chat_session) {
            dispatch(ChatActions.setvideoMode('Off'));
            handleFetchMessagesClick(chatState.lastReceivedMessage.chat_session, true)
            fetchUserSessions();
        } else {
            fetchUserSessions();
        }
    }, [chatState.isNewChat]);

    const handleFetchMessagesClick = (chatId: string, fetchFromStoreOnly: boolean = false) => {
        dispatch(ChatThunks.setIsNewChat(false));
        dispatch(handleFetchMessages(chatId, fetchFromStoreOnly));
        setChatStarted(true);
        setActiveChat(chatId)
    };

    const handleNewChat = () => {
        dispatch(ChatActions.setvideoMode('Off'));
        dispatch(ChatThunks.setIsNewChat(true));
        dispatch(ChatThunks.resetState());
        setInput(null);
        dispatch(ChatThunks.resetState());
        setChatStarted(false);
        fetchUserSessions();
        // fetchAndStoreToken();
        setIsAudioCallOpen(false);
    };

    // const handleFetchMessagesClick = async (chatId) => {
    //     try {
    //         const response = await ChatHistoryService.fetchSessionMessages(chatId);
    //         setChatMessages(response.data);
    //         setSelectedChatId(chatId);
    //         console.log(chatMessages)
    //     } catch (error) {
    //         console.error(`Error fetching messages for chat ${chatId}:`, error);
    //     }
    // };

    useEffect(() => {
        showNotNeededComponents = false
        const authToken = localStorage.getItem("authenticationToken") || null;
        const authTokenIsValid =
            authToken && authToken.trim().length > 0;

        const freeUsage = localStorage.getItem('freeUsageAllowed')
        if (!authTokenIsValid && (freeUsage == '0' || !freeUsage)) {
            navigate("/login");
        }
        if (authTokenIsValid) {
            showNotNeededComponents = true
        }
        document.title = "Talk To Marshall Goldsmith.";
    }, []);

    useEffect(() => {
        if (
            chatState.systemOverload &&
            chatState.systemOverload.system_overload
        ) {
            setOverloadOpen(chatState.systemOverload.system_overload);
        }
    }, [chatState.systemOverload]);

    const [isCopied, setIsCopied] = useState(false);

    const handleCloseSnackbar = () => {
        setIsCopied(false);
    };

    const fetchShareId = async (chatId) => {
        try {
            const response = await ConversationSharingService.fetchShareId(chatId);
            return (response.data.share_id);
        } catch (error) {
            console.error('Error fetching shareId:', error);
        }
    };

    const handleShareClick = async (sid) => {
        if (sid) {
            const shareId = await fetchShareId(sid);
            const baseURL = process.env.REACT_APP_BASE_URL
            const shareURL = `${baseURL}/get_shared_chat_messages/${sid}/${shareId}`;
            copy(shareURL)
            setIsCopied(true)
            // console.log(shareURL)
        } else {
            console.log('Error fetching Share URL');
        }
    };

    const [open, setOpen] = useState(false);
    const [newTitle, setNewTitle] = useState('');
    const [isPinned, setIsPinned] = useState(false)
    const [activeChatTitle, setActiveChatTitle] = useState('');
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedSessionId, setSelectedSessionId] = useState(null);

    const handleRenameClick = (sessionId) => {
        // setSelectedSessionId(sessionId);
        setOpen(true);
    };

    const handleRenameSubmit = async () => {
        if (selectedSessionId && newTitle) {
            try {
                const response = await RenameSessionService.renameSession(selectedSessionId, newTitle);
                // Update the session title in the userSessions array
                const updatedSessions = userSessions.map(session =>
                    session.sid === selectedSessionId ? { ...session, session_title: newTitle } : session
                );
                setUserSessions(updatedSessions);
                setOpen(false);
                setNewTitle('');
            } catch (error) {
                console.error("Failed to rename session:", error);
            }
        }
    };

    const handleDeleteSession = async () => {
        if (selectedSessionId) {
            try {
                const response = await DeleteSessionService.deleteSession(selectedSessionId);
                console.log(response.data);
                const updatedSessions = userSessions.filter(session => session.sid !== selectedSessionId);
                setUserSessions(updatedSessions);
                setOpenDeleteDialog(false);
            } catch (error) {
                console.error("Failed to delete session:", error);
            }
        }
    };

    const fetchUserSessionsAfterPinning = async () => {
        try {
            loadMoreUserSessions();
            // const response = await ChatHistoryService.fetchUserSessions();
            // setUserSessions(response.data);
        } catch (error) {
            console.error("Error fetching user sessions:", error);
        }
    };

    const handlePinClick = async (sessionId) => {
        try {
            const response = await PinUnpinSessionService.pinSession(sessionId);
            setIsPinned(true);
            // Update userSessions with the response from API
            setUserSessions(prev =>
                prev.map(session =>
                    session.sid === sessionId ? response.data : session
                )
            );
        } catch (error) {
            console.error("Error pinning session:", error);
        }
    };

    const handleUnpinClick = async (sessionId) => {
        try {
            const response = await PinUnpinSessionService.unpinSession(sessionId);
            setIsPinned(false);
            // Update userSessions with the response from API
            setUserSessions(prev =>
                prev.map(session =>
                    session.sid === sessionId ? response.data : session
                )
            );
        } catch (error) {
            console.error("Error unpinning session:", error);
        }
    };

    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event, sessionId, sessionPinned) => {
        setAnchorEl(event.currentTarget);
        setSelectedSessionId(sessionId);
        setIsPinned(sessionPinned)
    };

    const chatModeHandler = () => {
        setIsVideoModeOn(!isVideoModeOn)
        if (isVideoModeOn == false) {
            if (input?.trim().length > 0) {
                sessionStorage.setItem("freshInput", '1');
                submitMessage();
            } else {
                sessionStorage.setItem("freshInput", '0');
                setInput("");
            }
            sessionStorage.setItem("prevPath", '');
            setTimeout(() => {
                navigate('/video-chat')
            }, 500);
        }
    };


    const handleMenuClose = () => {
        setAnchorEl(null);
    };


const [offset, setOffset] = useState(0);
const [hasMoreSessions, setHasMoreSessions] = useState(true);


    const lastSessionElementRef = useCallback(
        (node: HTMLElement | null) => {
            if (userSessionsLoading === "loading") return;
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMoreSessions) {
                    loadMoreUserSessions();
                }
            });

            if (node) observer.current.observe(node);
        },
        [userSessionsLoading, hasMoreSessions]
    );

    const loadMoreUserSessions = async () => {
    if (!hasMoreSessions) return; // prevent unnecessary calls

    setUserSessionsLoading("loading");
    try {
        // Shared instance refreshes the token and retries on 401/403 (e.g. right after login)
        const response = await Axios.get("/api/v1/chat/user-sessions/", {
                            params: {
                                offset: offset,
                                limit: 10
                            }
                        });

        const newSessions = response.data.results || [];

        setUserSessions((prev) => [...prev, ...newSessions]);
        setOffset((prev) => prev + newSessions.length);

        // If the API returned fewer items than requested, or zero, no more sessions to load
        if (newSessions.length < 10) {
            setHasMoreSessions(false);
        } else {
            setHasMoreSessions(response.data.has_more);
        }

    } catch (error) {
        console.error("Error loading user sessions:", error);
        // Optionally stop loading on error to avoid repeated error loops
        setHasMoreSessions(false);
    } finally {
        setUserSessionsLoading("idle");
    }
};


    return (
        <div className="chat-v2-screen">
            <div className="big-container">
                {/* Hamburger for mobile */}
                {isDesktop === "mobile" && !showSidebar && (
                  <button
                    className="sidebar-toggle-btn"
                    style={{
                      position: 'absolute',
                      left: 6,
                      top: 100,
                      zIndex: 1001,
                      background: '#f0f0f0',
                      border: 'none',
                      fontSize: 32,
                      borderRadius: '50%',
                      width: 40,
                      height: 40,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                      cursor: 'pointer',
                    }}
                    onClick={() => setShowSidebar(true)}
                    aria-label="Open sidebar"
                  >
                    {/* History icon with right arrow */}
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                      {/* History Icon */}
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 3a9 9 0 1 0 8.485 6.071" stroke="#236B48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 7v5l4 2" stroke="#236B48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {/* Right Arrow */}
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 3l5 5-5 5" stroke="#236B48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                  </button>
                )}
                {/* Sidebar */}
                {showNotNeededComponents && showSidebar && (
                  <div className={`chat-history${isDesktop === "mobile" ? " mobile-sidebar" : ""}`}
                    style={isDesktop === "mobile" ? {
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      width: '100vw', // Match message-box width (full viewport width on mobile)
                      height: '100vh',
                      background: '#fff',
                      zIndex: 1000,
                      boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
                      transition: 'transform 0.3s',
                      overflowY: 'auto',
                    } : {}}
                  >
                    {/* Arrow to hide sidebar on mobile */}
                    {isDesktop === "mobile" && (
                      <button
                        style={{
                          position: 'absolute',
                          right: 10,
                          top: 14,
                          zIndex: 1001,
                          fontSize: 32,
                          background: '#f0f0f0',
                          border: 'none',
                          borderRadius: '50%',
                          width: 40,
                          height: 40,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                          cursor: 'pointer',
                        }}
                        onClick={() => setShowSidebar(false)}
                        aria-label="Hide sidebar"
                      >
                        {/* List icon with left arrow */}
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                          {/* List Icon */}
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 3a9 9 0 1 0 8.485 6.071" stroke="#236B48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M12 7v5l4 2" stroke="#236B48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          {/* Left Arrow */}
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 13L5 8L10 3" stroke="#236B48" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </span>
                      </button>
                    )}
                    {/* <div>
                        <h4 className="chat-history-header">Chat History</h4>


                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <strong>{isVideoModeOn ? "Video Mode" : "Text Mode"}</strong>
                            <Switch
                                checked={isVideoModeOn}
                                onChange={chatModeHandler}
                                color="primary"
                            />
                        </div>

                    </div> */}
                    <h4 className="chat-history-header">Chat History</h4>
                    <div className="chat-and-search-button">
                        <Button
                            disabled={chatState.isBotAnswering === "inprogress"}
                            className="new-chat-button"
                            onClick={() => {
                                handleNewChat();
                                setActiveChat("");
                                if (isDesktop === "mobile") setShowSidebar(false);
                            }}
                        >
                            <span>New Chat</span>
                            <img src={PlusIcon} alt="plus" style={{ width: "12px", height: "12px" }} />
                        </Button>
                    </div>
                    <p className="recent-text">Recent</p>
                    <div
                        className={`${userSessions.length === 0
                            ? "no-chats-container"
                            : "scrollable-list"
                            }`}
                    >
                        {/* {userSessions && userSessions.length === 0 ? (
                            <div className="no-chats">
                                <NoChat />
                                <div>No chats to show</div>
                            </div>
                        ) :
                         ( */}

                        {/* {
                            // userSessionsLoading === "loading" ? (
                            //     <div className="user-sessions-loading">
                            //         <LoadingIcon color="black" />
                            //     </div>
                            // ) :
                            userSessions.map((session, index) => (
                                <div key={index} className={`user-session-chat ${activeChat === session.sid
                                    ? "active-user-session"
                                    : ""
                                    }`}
                                    onClick={() => {
                                        setActiveChat(session.sid);
                                        setActiveChatTitle(session.session_title);
                                        setIsAudioCallOpen(false);
                                    }}>
                                    <div
                                        className="session-display"
                                        key={session.sid}
                                        onClick={() => {
                                            handleFetchMessagesClick(session.sid);
                                            setIsAudioCallOpen(false);
                                        }}
                                    >
                                        <div className="new-session-chip">
                                            <p className="new-chat-text">
                                                {session.session_title
                                                    ? session.session_title
                                                    : session.sid}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="session-functions">
                                        {session.pinned && (
                                            <PiPushPinBold style={{ fontSize: "16px", color: "grey", paddingRight: "1px" }} />
                                        )}
                                        <IconButton title="Click to copy Conversation URL to clipboard" onClick={() => handleShareClick(session.sid)}>
                                            <IosShareIcon className="session-icons" />
                                        </IconButton>
                                        <IconButton onClick={(event) => handleMenuOpen(event, session.sid, session.pinned)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            ))
                        } */}
                        <>
                        {userSessions?.map((session, index) => {
                                const isLastElement = userSessions?.length === index + 1;
                                return (
                                <div>
                                    <div
                                        key={session.sid}
                                        ref={isLastElement ? lastSessionElementRef : null}
                                        className={`user-session-chat ${
                                            activeChat === session.sid ? "active-user-session" : ""
                                        }`}
                                        onClick={() => {
                                            setActiveChat(session.sid);
                                            setActiveChatTitle(session.session_title);
                                            setIsAudioCallOpen(false);
                                        }}
                                    >
                                        <div
                                            className="session-display"
                                            onClick={() => {
                                                handleFetchMessagesClick(session.sid);
                                                setIsAudioCallOpen(false);
                                            }}
                                        >
                                            <div className="new-session-chip">
                                                <p
                                                    className="new-chat-text"
                                                    onClick={() => {
                                                        if (isDesktop === "mobile") setShowSidebar(false);
                                                    }}
                                                >
                                                    {session.session_title ? session.session_title : session.sid}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="session-functions">
                                            {session.pinned && (
                                                <div className="session-icon-button">
                                                    <IconButton className="session-icon">
                                                        <img src={UnpinIcon} style={{ width: "16px", height: "16px" }} alt="pinned" />
                                                    </IconButton>
                                                </div>
                                            )}
                                            {/* <IconButton
                                                title="Click to copy Conversation URL to clipboard"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleShareClick(session.sid);
                                                }}
                                            >
                                                <IosShareIcon className="session-icons" />
                                            </IconButton>
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleMenuOpen(e, session.sid, session.pinned);
                                                }}
                                            >
                                                <MoreVertIcon />
                                            </IconButton> */}
                                            <div className="session-icon-button"
                                                title="Click to copy Conversation URL to clipboard"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleShareClick(session.sid);
                                                }}
                                            >
                                                <IconButton className="session-icon">
                                                    <img src={ShareIcon} className="session-icons" alt="share" />
                                                </IconButton>
                                            </div>
                                            <div className="session-icon-button"
                                                title="Click to open menu"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleMenuOpen(e, session.sid, session.pinned);
                                                }}
                                            >
                                                <IconButton className="session-icon">
                                                    <img src={GroupActionsIcon} alt="actions" />
                                                </IconButton>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        );
                        })}

                            {userSessionsLoading === "loading" && (
                                <div className="user-sessions-loading">
                                    <LoadingIcon color="black" />
                                </div>
                            )}
                        </>
                        {/* )
                        } */}
                    </div>
                    <Menu
                        PaperProps={{ sx: { backgroundColor: "#FFFFFF", borderRadius: "5px", boxShadow: "0 0 0 1px #D8D6D2" }}}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                    >
                        <MenuItem onClick={() => { handleMenuClose(); handleRenameClick(activeChat); }}>
                            <ListItemIcon>
                                <img src={RenameIcon} style={{ width: "16px", height: "16px" }} alt="rename" />
                            </ListItemIcon>
                            <ListItemText className="action-list" primaryTypographyProps={{ style: { fontFamily: "'Fraunces', serif", fontSize: "14px", color: "#223C26" } }}>Rename Session</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => { handleMenuClose(); setOpenDeleteDialog(true); }}>
                            <ListItemIcon>
                                <img src={DeleteIcon} style={{ width: "16px", height: "16px" }} alt="delete" />
                            </ListItemIcon>
                            <ListItemText className="action-list" primaryTypographyProps={{ style: { fontFamily: "'Fraunces', serif", fontSize: "14px", color: "#223C26" } }}>Delete Session</ListItemText>
                        </MenuItem>
                        {isPinned ? (
                            <MenuItem onClick={() => { handleMenuClose(); handleUnpinClick(selectedSessionId); }}>
                                <ListItemIcon>
                                    <img src={UnpinIcon} style={{ fontSize: "16px", height: "16px" }} alt="unpin" />
                                </ListItemIcon>
                                <ListItemText className="action-list" primaryTypographyProps={{ style: { fontFamily: "'Fraunces', serif", fontSize: "14px", color: "#223C26" } }}>Unpin Session</ListItemText>
                            </MenuItem>
                        ) : (
                            <MenuItem onClick={() => { handleMenuClose(); handlePinClick(selectedSessionId); }}>
                                <ListItemIcon>
                                    <img src={PinIcon} style={{ width: "16px", height: "16px" }} alt="pin" />
                                </ListItemIcon>
                                <ListItemText className="action-list" primaryTypographyProps={{ style: { fontFamily: "'Fraunces', serif", fontSize: "14px", color: "#223C26" } }}>Pin Session</ListItemText>
                            </MenuItem>
                        )}
                    </Menu>
                    {/* Rename Dialog */}
                    <Dialog open={open} onClose={() => setOpen(false)}>
                        <div style={{ width: "280px", borderRadius: "50px" }}>
                            <DialogTitle style={{ fontSize: "20px", padding: "20px", color: "#595959", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                Rename Session
                            </DialogTitle>
                            <DialogContent style={{ fontSize: "17.5px", padding: "10px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="New Session Title"
                                    type="text"
                                    fullWidth
                                    value={newTitle}
                                    onChange={(e) => setNewTitle(e.target.value)}
                                    style={{ width: "90%", borderRadius: "10px" }}
                                />
                            </DialogContent>
                            <DialogActions style={{ display: "flex", justifyContent: "center", padding: "25px" }}>
                                <Button onClick={() => setOpen(false)} size="small"
                                    variant="outlined" style={{ color: "black", textTransform: "none", borderColor: "#c2c2c2", paddingLeft: "16px", paddingRight: "16px" }}>
                                    Cancel
                                </Button>
                                <Button onClick={handleRenameSubmit} size="small"
                                    variant="contained" style={{ textTransform: "none", backgroundColor: "#236B48", color: "white", paddingLeft: "16px", paddingRight: "16px" }} autoFocus>
                                    Rename
                                </Button>
                            </DialogActions>
                        </div>
                    </Dialog>
                    {/* Delete Dialog */}
                    <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                        <div style={{ width: "320px", borderRadius: "50px" }}>
                            <DialogTitle style={{ fontSize: "20px", padding: "14px", color: "#595959", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <img src={DeleteIcon} style={{ width: "16px", height: "16px" }} alt="delete" />
                            </DialogTitle>
                            <DialogContent style={{ fontSize: "16.5px", padding: "10px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                Are you sure you want to delete the session : "{activeChatTitle}" ?
                            </DialogContent>
                            <DialogActions style={{ display: "flex", justifyContent: "center", padding: "25px" }}>
                                <Button onClick={() => setOpenDeleteDialog(false)} size="small"
                                    variant="outlined" style={{ color: "black", textTransform: "none", borderColor: "#c2c2c2", paddingLeft: "16px", paddingRight: "16px" }}>
                                    Cancel
                                </Button>
                                <Button onClick={handleDeleteSession} size="small"
                                    variant="contained" style={{ textTransform: "none", backgroundColor: "#236B48", color: "white", paddingLeft: "16px", paddingRight: "16px" }} autoFocus>
                                    Delete
                                </Button>
                            </DialogActions>
                        </div>
                    </Dialog>
                    {/* Share Dialog */}
                    <Snackbar
                        open={isCopied}
                        autoHideDuration={3000}
                        onClose={handleCloseSnackbar}
                        message="Conversation URL copied to clipboard!"
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "center",
                        }}
                        sx={{
                            marginTop: "64px",
                            width: "100%",
                        }}
                    />
                </div>)}
                {!isAudioCallOpen && (
                <div
                    className={
                        chatState.chatType === "video"
                            ? "video-player container"
                            : "container"
                    }
                >
                    <div
                        className={
                            chatState.chatType === "video"
                                ? "hidden message-box"
                                : "message-box"
                        }
                    >
                        {chatStarted === true ? (
                            <>
                                <div className="messages" ref={messagesRef}>
                                    {chatState.isFetchingMessages ? (
                                        <div className="loading-messages">
                                            <LoadingIcon color="black" />
                                            <p>Loading messages...</p>
                                        </div>
                                    ) : (
                                        <>
                                            {renderMessages()}
                                            {canAccessQnA && chatState.summary && (
                                                <SummaryMessage
                                                    messageId="summary"
                                                    text={chatState.summary}
                                                    onTextContainerResized={scrollToLastMessage}
                                                />
                                            )}
                                        </>
                                    )}
                                </div>
                                {canAccessQnA && !chatState.summary && chatState.messages.length > 0 && (
                                    <div style={{ padding: "12px 0", textAlign: "center" }}>
                                        <button
                                            onClick={handleGenerateSummary}
                                            disabled={isSummaryLoading}
                                            title={summaryError || ""}
                                            style={{
                                                padding: "6px 16px",
                                                borderRadius: "20px",
                                                border: "none",
                                                backgroundColor: isSummaryLoading ? "#E0E0E0" : "#236B48",
                                                color: isSummaryLoading ? "#999" : "white",
                                                fontSize: "12px",
                                                fontWeight: "500",
                                                cursor: isSummaryLoading ? "not-allowed" : "pointer",
                                                transition: "all 0.3s ease",
                                                display: "inline-block",
                                                whiteSpace: "nowrap"
                                            }}
                                        >
                                            {isSummaryLoading ? "Generating..." : "Generate Summary"}
                                        </button>
                                    </div>
                                )}
                                <>
                                    {chatState.sendMessageApiStatus ===
                                        "inprogress" && (
                                            <div className="waiting-message">
                                                <div className="lds-ellipsis">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div>
                                                <div className="text">
                                                    <Typography variant="body1">
                                                        Marshall is thinking...
                                                    </Typography>
                                                </div>
                                            </div>
                                        )}
                                </>
                            </>
                        ) : (
                            <div className="message-placeholder">
                                {/* <DesktopViewPlaceholder
                                    handleExampleClick={handleExampleClick}
                                />
                                <MobileViewPlaceholder
                                    handleExampleClick={handleExampleClick}
                                /> */}
                                <div className="suggestion-container">
                                    <div className="suggestion-header">
                                        <div
                                            className="i-icon"
                                            onClick={() => setInfoModal(true)}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                            >
                                                <g
                                                    opacity="0.4"
                                                    clipPath="url(#clip0_1026_655)"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M7.99935 2.00008C4.68564 2.00008 1.99935 4.68637 1.99935 8.00008C1.99935 11.3138 4.68564 14.0001 7.99935 14.0001C11.3131 14.0001 13.9993 11.3138 13.9993 8.00008C13.9993 4.68637 11.3131 2.00008 7.99935 2.00008ZM0.666016 8.00008C0.666016 3.94999 3.94926 0.666748 7.99935 0.666748C12.0494 0.666748 15.3327 3.94999 15.3327 8.00008C15.3327 12.0502 12.0494 15.3334 7.99935 15.3334C3.94926 15.3334 0.666016 12.0502 0.666016 8.00008Z"
                                                        fill="black"
                                                    />
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M8.00065 7.33325C8.36884 7.33325 8.66732 7.63173 8.66732 7.99992V10.6666C8.66732 11.0348 8.36884 11.3333 8.00065 11.3333C7.63246 11.3333 7.33398 11.0348 7.33398 10.6666V7.99992C7.33398 7.63173 7.63246 7.33325 8.00065 7.33325Z"
                                                        fill="black"
                                                    />
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M7.33398 5.33341C7.33398 4.96522 7.63246 4.66675 8.00065 4.66675H8.00732C8.37551 4.66675 8.67398 4.96522 8.67398 5.33341C8.67398 5.7016 8.37551 6.00008 8.00732 6.00008H8.00065C7.63246 6.00008 7.33398 5.7016 7.33398 5.33341Z"
                                                        fill="black"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1026_655">
                                                        <rect
                                                            width="16"
                                                            height="16"
                                                            fill="white"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="suggestion-intro">
                                        <div className="conversation-label">A CONVERSATION WITH</div>
                                        <h2 className="suggestion-title">What got you here won't get you there.</h2>
                                        <p className="suggestion-subtitle">I'm Marshall. For forty years I've helped successful leaders get even better. Ask me anything — or begin with one of these.</p>
                                    </div>
                                    <div className="cards-container">
                                        {cardContent.map((each: any) => (
                                            <div
                                                key={each.id}
                                                className="card"
                                                onClick={() => handleExampleClick(each.text)}
                                            >
                                                <div className="card-image-wrapper">
                                                    <img
                                                        src={each.image}
                                                        alt={each.text}
                                                        className="card-image"
                                                    />
                                                </div>
                                                <div className="card-content">
                                                    <div className="card-category">{each.category}</div>
                                                    <h3 className="card-title">{each.text}</h3>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <br />
                                    {/* {canAccessQnA &&<div className="book-banner" onClick={() => navigate('/book')}>
                                        Click here to read the book
                                    </div>} */}
                                </div>
                            </div>
                        )}
                    </div>
                    <div
                        className={
                            chatState.chatType !== "video"
                                ? "hidden video-player-box"
                                : "video-player-box"
                        }
                    >
                        <video
                            width="100%"
                            height="100%"
                            ref={videoRef}
                            autoPlay
                            onPlay={handleVideoPlay}
                        >
                            <source type="video/mp4" />
                        </video>
                        {!isVideoPlaying && (
                            <img
                                src={mgVideoImageUrl}
                                alt="Image"
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    zIndex: 1,
                                }}
                            />
                        )}
                        {chatState.sendMessageApiStatus === "inprogress" && (
                            <div className="waiting-message-video">
                                <div className="lds-ellipsis-video">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div className="text-video">
                                    <Typography variant="body1">
                                        MarshallBot is thinking...
                                    </Typography>
                                </div>
                            </div>
                        )}
                    </div>
                    <div
                        className={`input ${showRecordingDialog || showTranscribing ? "input-for-recording" : ""
                            }`}
                    >
                        {showRecordingDialog || showTranscribing ? (
                            <div className="recording-container">
                                <div className="first-container">
                                    <div className="timer">
                                        <div className="second-cirlce">
                                            <div className="first-circle">
                                                <div className="time">
                                                    {time.minutes +
                                                        " : " +
                                                        time.seconds}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div
                                        className="audio-wave"
                                        ref={waveformRef}
                                    ></div> */}
                                    {/* <AudioWaveform audioBlob={transcript.blob} /> */}
                                    <div className="mg-voice-visualizer">
                                        <VoiceVisualizer
                                            ref={audioRef}
                                            controls={recorderControls}
                                            height={70}
                                            width={"100%"}
                                            mainBarColor="#FBB117"
                                            canvasContainerClassName="canvas-container"
                                            isControlPanelShown={false}
                                            barWidth={4}
                                            secondaryBarColor="#EFEEEE"
                                        />
                                    </div>
                                    <div
                                        className={`stop-recording${showTranscribing ? " transcribing" : ""}`}
                                        onClick={() => {
                                            if (showTranscribing) return;
                                            markStopping();
                                            stopRecording();
                                            setIsRunning(false);
                                            setTime({
                                                minutes: 0,
                                                seconds: 0,
                                            });
                                            stopVisualRecording();
                                            stopUpdatingSeconds();
                                            resetTranscript();
                                            setShowRecordingDialog(false);
                                            setMessageInputType("text");
                                        }}
                                    >
                                        <p>{showTranscribing ? "Transcribing..." : "Stop recording"}</p>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="34"
                                            height="35"
                                            viewBox="0 0 34 35"
                                            fill="none"
                                        >
                                            <path
                                                d="M16.6667 0.833252C14.478 0.833252 12.3107 1.26435 10.2886 2.10193C8.26652 2.9395 6.4292 4.16716 4.88155 5.71481C1.75595 8.84041 0 13.0796 0 17.4999C0 21.9202 1.75595 26.1594 4.88155 29.285C6.4292 30.8327 8.26652 32.0603 10.2886 32.8979C12.3107 33.7355 14.478 34.1666 16.6667 34.1666C21.0869 34.1666 25.3262 32.4106 28.4518 29.285C31.5774 26.1594 33.3333 21.9202 33.3333 17.4999C33.3333 15.3112 32.9022 13.144 32.0647 11.1219C31.2271 9.09977 29.9994 7.26245 28.4518 5.71481C26.9041 4.16716 25.0668 2.9395 23.0447 2.10193C21.0226 1.26435 18.8554 0.833252 16.6667 0.833252ZM11.6667 12.4999H21.6667V22.4999H11.6667"
                                                fill="#F06055"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div className="second-container">
                                    <div className="loader-and-input">
                                        <div className="bouncing-loader">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <p>{input}</p>
                                    </div>
                                    <div className="silence-warning">
                                        {secondsRef.current > 1
                                            ? `Silence detected. Stopping recording in ${secondsRef.current}s`
                                            : ""}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="text-field">
                                <TextField
                                    fullWidth
                                    multiline
                                    // disabled={
                                    //     chatState.setStreamStarted==1
                                    // }
                                    className="input-field"
                                    maxRows={2}
                                    placeholder={
                                        messageInputType === "voice"
                                            ? "Listening"
                                            : "Type your message here..."
                                    }
                                    value={input !== null ? input : ""}
                                    inputRef={inputRef}
                                    onKeyUp={(event) => {
                                        if (event.key === "Enter") {
                                            if (input.trim().length > 0) {
                                                (!chatState.isBotAnswering || chatState.isBotAnswering ===
                                                    "success") &&
                                                    submitMessage();
                                            } else {
                                                setInput("");
                                            }
                                        }
                                    }}
                                    onChange={(event) => {
                                        setInput(event.target.value);
                                        setIsTyping(
                                            event.target.value.length > 0,
                                        );
                                    }}
                                    onFocus={() => setIsTyping(true)}
                                    InputProps={{
                                        readOnly:
                                            process.env.NODE_ENV ===
                                            "production" &&
                                            messageInputType === "voice",
                                        endAdornment: (
                                            <>
                                                <IconButton
                                                    title={
                                                        messageInputType === "text"
                                                            ? "Turn On Microphone"
                                                            : "Turn Off Microphone"
                                                    }
                                                    onClick={() => {
                                                        toggleChatInputType();
                                                        handleVoiceVisualizer();
                                                    }}
                                                    style={{
                                                        color: messageInputType === "voice" ? "#236B48" : "#525252"
                                                    }}
                                                >
                                                    <img src={SpeechToText} style={{ width: "16px", height: "16px" }} alt="microphone" />
                                                </IconButton>
                                                <IconButton
                                                    title="Send"
                                                    // disabled={
                                                    //     chatState.isBotAnswering ===
                                                    //     "inprogress" ||
                                                    //     chatState.sendMessageApiStatus ===
                                                    //     "inprogress"
                                                    // }
                                                    onClick={submitMessage}
                                                >
                                                    <img src={SendMessageIcon} alt="send" style={{ width: "32px", height: "32px" }} />
                                                </IconButton>
                                            </>
                                        ),
                                    }}
                                />
                                {canAccessQnA && (
                                    <div>
                                        <IconButton
                                            className="icon-button microphone"
                                            title={isAudioCallOpen ? "Close Audio Call" : "Start Audio Call"}
                                            // disabled={
                                            //     chatState.sendMessageApiStatus ===
                                            //     "inprogress" ||
                                            //     chatState.isBotAnswering ===
                                            //     "inprogress"
                                            // }
                                            onClick={() => setIsAudioCallOpen(!isAudioCallOpen)}
                                        >

                                            <div className="mic-button">
                                                <img src={AudioCallIcon} alt="audio" />
                                            </div>

                                        </IconButton>
                                    </div>
                                )}
                                {/* Commenting on 22 Sep 2026 */}
                                {/* {canAccessQnA && (
                                    <div>
                                        <IconButton
                                            className="icon-button "
                                            title="Start Video Mode"
                                            onClick={
                                                chatModeHandler
                                            }
                                        >
                                            <div className="video-button">
                                                <Videocam />
                                            </div>
                                        </IconButton>
                                    </div>
                                )} */}
                            </div>
                        )}
                    </div>
                    {/* <div className="powered-by">
                        <div className="text">Powered by</div>
                        <img src={genesisLogoUrl} alt="Genesis Logo" />
                    </div> */}
                </div>
                )}
                {isAudioCallOpen && (
                    <div className="audio-call-panel">
                        <AudioCallComponent onClose={() => {
                            setIsAudioCallOpen(false);
                            // Check if there's a chat session in localStorage (new audio call)
                            const chatSessionFromStorage = localStorage.getItem("chat_session_id");
                            const chatToLoad = activeChat || chatSessionFromStorage;
                            if (chatToLoad) {
                                // handleFetchMessagesClick will now fetch summary automatically
                                handleFetchMessagesClick(chatToLoad, false);
                            }
                        }} chatSessionId={activeChat} />
                    </div>
                )}
            </div>
            {showNotNeededComponents && (
                <Footer />
            )}

            <Paper className="no-screen-support">
                <Typography variant="body1" align="center">
                    We do not support landscape mode on mobile devices. Switch
                    to portrait mode for better experience.
                </Typography>
            </Paper>

            {/* Dialogs */}
            <RestartConversationDialog
                isOpen={confirmationDialogOpen}
                onClose={() => {
                    setConfirmationDialogOpen(false);
                }}
                onConfirm={() => {
                    setConfirmationDialogOpen(false);
                    setInput(null);
                    dispatch(ChatThunks.resetState());
                    setChatStarted(false);
                }}
            />

            <FeedbackDialog
                isOpen={showFeedbackDialog}
                onClose={() => {
                    setShowFeedbackDialog(false);
                    setMessageIdForFeedback(null);
                }}
                onConfirm={(
                    feedbackText: string,
                    feedbackChoices: string[],
                ) => {
                    submitFeedback(
                        messageIdForFeedback,
                        "TD",
                        feedbackText,
                        feedbackChoices,
                    );
                }}
                messageFeedbackApiStatus={chatState.messageFeedbackApiStatus}
            />

            <VoiceListening
                isOpen={false}
                onClose={() => {
                    stopRecording();
                    resetTranscript();
                    setShowRecordingDialog(false);
                    setMessageInputType("text");
                    setInput("");
                }}
                onConfirm={() => {
                    if (input.trim().length > 0) {
                        stopRecording();
                        submitMessage();
                        setActiveChat("");
                        setShowRecordingDialog(false);
                    }
                }}
                isDisabled={!input || (input && input.trim().length === 0)}
            />

            <Snackbar
                sx={{ maxWidth: 240 }}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={snackbarProps.open}
                autoHideDuration={2000}
                message={snackbarProps.message}
                onClose={onSnackbarClose}
                action={
                    <IconButton onClick={onSnackbarClose}>
                        <Close htmlColor="white" />
                    </IconButton>
                }
            />
            <InforDialog
                isOpen={infoModal}
                onClose={() => setInfoModal(false)}
            />
            {/* <Modal open={false} className="system-overload-modal">
                <Card className="system-overload-card">
                    <div className="system-overload-content">
                        <p>Exceed limit message</p>
                        <Button variant="contained">OK</Button>
                    </div>
                </Card>
            </Modal> */}
            <Snackbar
                sx={{ maxWidth: 240 }}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                open={overloadOpen}
                autoHideDuration={2000}
                message={chatState.systemOverload.message}
                onClose={() => setOverloadOpen(false)}
                action={
                    <IconButton onClick={() => setOverloadOpen(false)}>
                        <Close htmlColor="white" />
                    </IconButton>
                }
            />
        </div>
    );
};

export default ChatV2;
